import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import { FallbackProps } from 'react-error-boundary';

function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <MDBox role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <MDButton onClick={resetErrorBoundary}>Try again</MDButton>
    </MDBox>
  );
}

export default ErrorFallback;
